// extracted by mini-css-extract-plugin
export default {"checkbox_font_weight":"400","checkbox_space_between":"10px","checkbox_size":"18px","checkbox_diff_between_input_and_text":"3px"};